import { ONBOARDING_PATHS } from './draft';

/**
 * Куда вести «Назад», когда в истории вкладки нет предыдущей страницы (ревью 2026-09-24).
 * Возврат в анкету открывает сохранённый шаг с `replace`, и `navigate(-1)` уводил из приложения.
 * Шаг анкеты возвращает на предыдущий шаг, остальные экраны — в корень (там AppGate решит сам).
 */
export function backFallback(pathname: string): string {
  const step = (ONBOARDING_PATHS as readonly string[]).indexOf(pathname);
  if (step > 0) return ONBOARDING_PATHS[step - 1] ?? '/';
  return '/';
}

/** Есть ли куда вернуться внутри приложения: react-router хранит номер записи в `history.state.idx`. */
export function hasInAppHistory(state: unknown): boolean {
  const idx = (state as { idx?: unknown } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
}
